import { LISTENING, SPEAKING, READING, WRITING } from './TaskManagementOption';

export const REGULATION = 'regulation';
export const FRAUD = 'fraud';
export const VIOLATION_TYPES = [
  { id: REGULATION, name: 'Vi phạm quy chế' },
  { id: FRAUD, name: 'Vi phạm gian lận' }
];
export const VIOLATION_SKILLS = [
  { id: LISTENING, name: 'Nghe' },
  { id: SPEAKING, name: 'Nói' },
  { id: READING, name: 'Đọc' },
  { id: WRITING, name: 'Viết' }
];
export function violationStudentLabel(student) {
  return [student.user_name, student.student_code, student.phone, student.classroom_code].filter(Boolean).join(' - ');
}
export function violationLink(value) {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
  } catch (error) {
    return '';
  }
}
